import { NotificationsContextProvider } from '@csp/web-common';
import { FC, PropsWithChildren } from 'react';
import { StudiesContextProvider } from './common/context/studies/StudiesContextProvider';
import { ConsentContextProvider } from './feature/consent/context/ConsentContextProvider';
import { ZoomContextProvider } from './feature/video-meeting/zoom/context/ZoomContextProvider';
import { AuthenticatedRedirectContextProvider } from './feature/navigation/context/AuthenticatedRedirectContextProvider';
import { AutomaticLogoutContextProvider } from './feature/security/context/AutomaticLogoutContextProvider';

export const CspProviders: FC<PropsWithChildren> = ({ children }) => (
  <AuthenticatedRedirectContextProvider>
    <AutomaticLogoutContextProvider>
      <StudiesContextProvider>
        <NotificationsContextProvider>
          <ConsentContextProvider>
            <ZoomContextProvider>{children}</ZoomContextProvider>
          </ConsentContextProvider>
        </NotificationsContextProvider>
      </StudiesContextProvider>
    </AutomaticLogoutContextProvider>
  </AuthenticatedRedirectContextProvider>
);
